/** @fileoverview The small animated mark shown while the assistant works, stepping through star glyphs. */

import { useEffect, useState } from 'react';

/** Frames in display order; the sequence grows then shrinks so the mark seems to breathe. */
const FRAMES = Object.freeze(['·', '✢', '✳', '✶', '✻', '✽', '✻', '✶', '✳', '✢']);
const FRAME_MS = 120;
const RESTING_FRAME = '✻';

/** Returns true when the viewer asked the system for less motion. */
const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** Steps through the glyph frames in the brand colour, or holds one glyph under reduced motion. */
export default function WorkingMark({ className = '' }: { className?: string }) {
  const [frameIndex, setFrameIndex] = useState(0);
  const [reduceMotion] = useState(prefersReducedMotion);

  useEffect(() => {
    if (reduceMotion) return undefined;
    const timer = window.setInterval(
      () => setFrameIndex((current) => (current + 1) % FRAMES.length),
      FRAME_MS
    );
    return () => window.clearInterval(timer);
  }, [reduceMotion]);

  return (
    <span
      className={`inline-block w-4 shrink-0 text-center font-mono text-base leading-none text-app-brand ${className}`}
      aria-hidden="true"
    >
      {reduceMotion ? RESTING_FRAME : FRAMES[frameIndex]}
    </span>
  );
}
